import AttendanceSerializer from './base';

export default class Suspension extends AttendanceSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      category: 0,
      reason: 0,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
